import styles from './index.module.css';
import { useTranslation } from 'react-i18next';

///////////////////////////////////////////////////
////// TYPES

interface Props {
  children: JSX.Element[] | JSX.Element | string;
  label: string;
  subLabel?: string;
}

///////////////////////////////////////////////////
////// COMPONENT

export function ItemsPage(props: Props) {
  const { t } = useTranslation();
  return (
    <div className={styles.Question}>
      <label className={styles.Label}>{t(props.label)}</label>
      {props.subLabel ? (
        <label className={styles.Sublabel}>{t(props.subLabel)}</label>
      ) : null}
      {props.children}
    </div>
  );
}
